<form [formGroup]="utilizationOptionsForm" (ngSubmit)="onSubmit()" class="example-form settings-form">

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.settingForm.title' | translate}}</mat-label>
        <input formControlName="title" matInput type="text" required>
    </mat-form-field>
    <div>{{'FORM.utilizationOptionForm.title_util_option_sel' | translate}}</div>
    <div class="d-flex justify-content-between align-items-center my-3">
        <div>{{'FORM.utilizationOptionForm.choose' | translate}}</div>
        <div>
            <mat-radio-group formControlName="personPickerMode">
                <mat-radio-button value="none">{{'FORM.utilizationOptionForm.options.none' | translate}}</mat-radio-button>
                <mat-radio-button value="optional">{{'FORM.utilizationOptionForm.options.optional' | translate}}</mat-radio-button>
                <mat-radio-button value="mandatory">{{'FORM.utilizationOptionForm.options.mandatory' | translate}}</mat-radio-button>
                <mat-radio-button value="predefined">{{'FORM.utilizationOptionForm.options.predefined' | translate}}</mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
    
    <div [hidden]="!showPersonSelect">
        <mat-form-field class="w-100 mb-1">
            <mat-label>{{'FORM.utilizationOptionForm.choose_person' | translate}}</mat-label>
            <mat-select formControlName="person">
                <mat-option *ngFor="let person of data.person" [value]="person">{{person.anzeigeName}}</mat-option>
            </mat-select>
            <mat-error *ngIf="utilizationOptionsForm.errors?.personRequired">{{'FORM_VALIDATION.REQUIRED' | translate}}</mat-error>
        </mat-form-field>
    </div>
    <div>
        <button [disabled]="utilizationOptionsForm.invalid || updateRight" class="my-4 first-stt-btn w-100" mat-raised-button type="submit">
                {{ 'FORM.BTN_SAVE' | translate }}
        </button>

        <button [disabled]="isCreate || deleteRight" class="w-100 second-stt-btn mb-2" style="float:inline-end;" mat-button (click)="onDelete()">
            {{ 'FORM.BTN_DELETE' | translate }}
        </button>
    </div>    
</form>
